import { useEffect, useState } from 'react';

export type CoreTheme = 'dark' | 'light';

const storageKey = 'cv-theme';
const documentThemeAttribute = 'data-core-theme';

export function useCoreTheme() {
    const [ theme, setTheme ] = useState<CoreTheme>('dark');

    useEffect(() => {
        const storedTheme = localStorage.getItem(storageKey) === 'light' ? 'light' : 'dark';
        document.documentElement.setAttribute(documentThemeAttribute, storedTheme);
        setTheme(storedTheme);
    }, []);

    const toggleTheme = () => {
        setTheme(current => {
            const next = current === 'dark' ? 'light' : 'dark';
            localStorage.setItem(storageKey, next);
            document.documentElement.setAttribute(documentThemeAttribute, next);
            return next;
        });
    };

    return { theme, toggleTheme };
}
